import axios from 'axios'
import router from '@/router'
import { getToken, removeToken } from './auth'
// import Vue from 'vue'
import { Message } from 'element-ui'
import i18n from '@/lang' // internationalization
// const i18n = Vue.prototype.$i18n
// eslint-disable-next-line no-unused-vars
const timer = 1000

// import store from '@/store'
// import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  const TOKEN = getToken() || null
  // store.state.auth.logToken
  if (TOKEN) {
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json'
    }
    config.headers.Authorization = 'Bearer ' + TOKEN
  }
  return config
})

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  // response => {
  // const res = response.data

  // if the custom code is not 20000, it is judged as an error.
  // if (res.code !== 401) {
  // Message({
  //   message: res.message || 'Error',
  //   type: 'error',
  //   duration: 5 * 1000
  // })

  // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
  // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //   // to re-login
  //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
  //     confirmButtonText: 'Re-Login',
  //     cancelButtonText: 'Cancel',
  //     type: 'warning'
  //   }).then(() => {
  //     store.dispatch('user/resetToken').then(() => {
  //       location.reload()
  //     })
  //   })
  // }
  // return Promise.reject(new Error(res.message || 'Error'))
  // } else {
  // return res
  // removeToken()
  // router.push('/login')
  // }
  // },
  response => {
    return response?.data
  },
  error => {
    const status = error.response?.status
    if (status !== 401) {
      return Promise.reject(error)
    } else {
      logout()
    }
  }
)
let a = false
function logout() {
  function debounce() {
    if (!a) {
      a = true
      setTimeout(() => {
        Message({
          message: i18n.t('errorMsg.authentication'),
          type: 'error',
          duration: 4 * 1000
        })
        removeToken()
        router.push('/login')
        a = false
      }, 1000)
    }
  }
  debounce()
}

export default service
